import { TemplatesConsole } from '@speles7172/message-console';
import '@speles7172/message-console/styles.css';
import { BRAND_NAME } from '@peles/shared';
import { templatesTransport } from '../../api/messageTemplates';
import { RoleCapabilitiesGrid } from './RoleCapabilitiesGrid';
import { AutomationsPanel } from './AutomationsPanel';

/**
 * Settings → Messaging: the wording of every email and notification the
 * application sends — guest invitations, RSVP confirmations, the enquiry
 * auto-reply, questionnaire links, conversation notices — edited without a
 * deploy, previewed against example values, and put back to the default in one
 * click.
 *
 * The screen is the package's `<TemplatesConsole>`, whole, for the reason
 * `NotificationsPage` renders its console whole. The structure of each email
 * (buttons, calendar links, the campaign's artwork) is built by the
 * application and appears in a template as a `{{block:…}}`; the wording
 * around it is what an administrator edits.
 */
export function MessagingTab() {
  return (
    <div className="p-4 sm:p-6">
      <RoleCapabilitiesGrid area="Messaging" />
      <AutomationsPanel />
      <p className="text-sm text-gray-600 mb-4 max-w-3xl">
        The wording of every email and notification the app sends. Changes apply to the next message
        sent. Merge tags like <code>{'{{guestName}}'}</code> are filled in for each recipient;
        blocks like <code>{'{{block:rsvpButtons}}'}</code> are parts the app draws (buttons, links,
        artwork) — keep them where they belong in the text.
      </p>
      <div className="peles-controls">
        <TemplatesConsole
          transport={templatesTransport}
          title="Messages"
          branding={{ productName: BRAND_NAME, accentColor: '#7c3aed' }}
        />
      </div>
    </div>
  );
}
